import React, { useState, useEffect } from "react";

// Component
import SearchForm from "../../../../component/search-form";
import { sanitizeInput } from "../../../../utils";
import useDebounce from "../../../../Hook/useDebounce";
import BulkProductionTable from "./BulkProductionTable";
import * as XLSX from "xlsx";
import UploadCSVFile from "./UploadCSVFile";
import { addBulkProductionOrder } from "../../../../redux/actions/productMaster";
import { useDispatch } from "react-redux";

function BulkProductionIndex() {
  // State
  const [searchText, setSearchText] = useState();
  const [buttonClick, setButtonClick] = useState(false);
  const [openModalPopup, setOpenModalPopup] = useState(false);
  const [fileURL, setfileURL] = useState();
  const [tableLoader, setTableLoader] = useState(false);
  const [update, setUpdate] = useState(1);

  const dispatch = useDispatch();

  const debouncedSearchText = useDebounce(searchText, 300);

  // Function to call bulk production API
  const bulkProductionUsingCSV = (payload) => {
    setOpenModalPopup(false);
    setTableLoader(true);
    const request = {
      payload,
      onSuccess: () => {
        setUpdate(update + 1);
        setTableLoader(false);
      },
      onError: (error) => {
        setTableLoader(false);
      },
    };
    dispatch(addBulkProductionOrder(request));
  };

  // Function to create payload from uploaded .csv file
  const createPayload = (jsonData) => {
    const jsonDataKeysArr = [
      ...new Set(jsonData.map((item) => Object.keys(item)).flat()),
    ];

    const payloadArr = jsonDataKeysArr
      .filter((ele) => ele.includes("Week"))
      .map((item) => {
        const obj = {
          weekNumber: Number(item.split(" ")[1]),
        };
        return obj;
      });

    payloadArr.forEach((payloadEle) => {
      payloadEle.products = jsonData
        .filter((filteredItem) =>
          filteredItem.hasOwnProperty(`Week ${payloadEle.weekNumber}`) && filteredItem[`Week ${payloadEle.weekNumber}`]
        )
        .map((mappedItem) => {
          if (mappedItem[`Week ${payloadEle.weekNumber}`]) {
            const obj = {
              product_master_id: mappedItem.product_id,
              qty: mappedItem[`Week ${payloadEle.weekNumber}`],
            };
            return obj;
          }
        });
    });

    const bulkProductionPayload = payloadArr.filter((item) => item.products.length > 0)

    bulkProductionUsingCSV(bulkProductionPayload);
  };

  // Function to create excel file
  const createExcelFile = (jsonData) => {
    const header = Object.keys(jsonData[0]);
    console.log({ header, jsonData });
    const wb = XLSX.utils.book_new();

    const ws = XLSX.utils.json_to_sheet(jsonData);
    ws["!cols"] = header.map((item) => {
      return item === "product_id" ? { hidden: true } : { wch: 12 };
    });

    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

    const excelOutput = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

    const blob = new Blob([s2ab(excelOutput)], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const url = URL.createObjectURL(blob);
    setfileURL(url);
  };

  // Helper function to convert string to ArrayBuffer
  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };

  // Function to generate json for creating excel file
  const generateJson = (data) => {
    const jsonArr = data.map((item) => {
      const obj = {
        product_id: item.product_master_id,
        product: item.product_name,
      };

      item.weekWise.forEach((element) => {
        obj[`Week ${element.weekNumber}`] = "";
      });

      return obj;
    });
    createExcelFile(jsonArr);
  };

  // Function to extract data from excel
  const handleExcelFileUpload = (uploaded_file_data) => {
    const file = uploaded_file_data;
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });

      // Assuming you're reading the first sheet
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert the sheet to JSON
      const jsonData = XLSX.utils.sheet_to_json(worksheet);
      createPayload(jsonData);
    };
    reader.readAsArrayBuffer(file);
  };

  return (
    <div className="space-y-2">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-4 px-6 py-4 bg-[--bg-color-50] rounded">
        <div className="space-x-4 flex items-center">
          <h4 className="text-xl leading-5 font-bold tracking-tight">
            Production Orders
          </h4>
          <SearchForm
            placeholder="Search"
            onChange={(e) => {
              const value = sanitizeInput(e.target.value);
              setSearchText(value);
            }}
            value={searchText}
          />
        </div>

        <div className="space-x-4 flex items-center justify-end">
          <button
            onClick={() => setOpenModalPopup(true)}
            className="btn ml-0 md:ml-3 btn bg-white border-slate-200 hover:border-slate-300 text-slate-600"
          >
            Upload .xlsx File
          </button>
          <button
            className="btn ml-0 md:ml-3 !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
            onClick={() => setButtonClick(true)}
          >
            Save
          </button>
        </div>
      </div>
      <BulkProductionTable
        debouncedSearchText={debouncedSearchText}
        buttonClick={buttonClick}
        setButtonClick={setButtonClick}
        generateJson={generateJson}
        update={update}
        setUpdate={setUpdate}
        tableLoader={tableLoader}
        setTableLoader={setTableLoader}
      />

      <UploadCSVFile
        openModalPopup={openModalPopup}
        setOpenModalPopup={setOpenModalPopup}
        handleExcelFileUpload={handleExcelFileUpload}
        fileURL={fileURL}
      />
    </div>
  );
}

export default BulkProductionIndex;
